// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/BackgroundLoginLeft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/Pattern 2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    font-family: 'Sora', sans-serif;
}

.loginRight {
    background-color: hsl(200, 33%, 98%);
    width: 50%;
    height: 100vh;
}

.background-image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    max-width: 100%;
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
}

.login-form-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position-y:-10px;
    background-position-x:-30px;
    width: 100% !important;
    height: calc(100vh - 60px);
    background-color: #FFFFFF;
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);
    padding: 66px 106px 26px 66px;
    margin-top: 20px;
    margin-bottom: 50px;
    border-radius: 8px;
    margin-left: -80px;
    margin-right: 50px;
    overflow-y: auto;
}

.appVersion {
    text-align: left;
    font-size: 12px;
}


.login-password {
    border-radius: 12px !important;
}

.login-email {
    border-radius: 12px !important;

}

.headerTitle {
    font-family: 'Sora', sans-serif;
    font-weight: 100 !important;
    color: #1D1E25;
}

.headerParagraph {
    font-family: 'Sora', sans-serif;
    font-weight: 200 !important;
    font-size: 16px;
    line-height: 26px;
    color: #1D1E2599;
    margin-bottom: 40px;
}

.headerLink {
    color: #F15F50;
    font-size: 20px;
    line-height: 30px;
    text-align: right;
    text-decoration: underline;
}

#email,
#password {
    border-radius: 5px;
    border-left: none;
    margin-left: 15px;
}

#email:focus {
    box-shadow: none;
    outline: none;
    border-left: none;


}

#password:focus {
    box-shadow: none;
    outline: none;
    border-left: none;



}

.input-group {
    width: 100%;
}

/* .input-with-icon {
    padding-left: 40px;
    background-repeat: no-repeat;
    background-position: 10px center;
}

.input-with-icon#email {
    background: url('../images/icons/Email.png') no-repeat scroll 10px center;
    margin-left: -40px;
}

.input-with-icon#password {
    background: url('../images/icons/Password.png') no-repeat scroll 10px center;
    margin-left: -40px;
} */

.form-control {
    color: #1D1E25;
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
}

.logoBackgroundDiv {
    width: 400px;
    height: 200px;
    margin-bottom: 20px;

}

.yerimLogo {
    width: 229px !important;
    height: 180px !important;
    z-index: 9999;
}

.forgotPasswordDiv {
    display: flex;
    text-align: right;
    justify-content: end;
    margin-top: 10px;
    margin-bottom: 10px;
}

.forgotPasswordDiv p {
    color: #ed5746;
}

.forgotPassword {
    color: #1D1E25;
    font-size: 14px;
}

.signIn {
    /* padding: 18px 22px 18px 22px; */
    width: 312px;
    height: 56px;
    background-color: #F15F50;
    justify-content: space-between;
    border-radius: 12px;
    border: none;
    margin-top: 10px;
}

.signIn:hover {
    background-color: #ed5746;

}



.eyeButton {
    border: none;
    margin-left: -50px;
    margin-top: 10px;
    z-index: 999 !important;
}

.envelopeIcon,
.keyIcon {
    margin-top: 15px;
    margin-right: -5px;
    z-index: 999;
}

.loginHeader {
    margin-bottom: 20px;
}



.Links {
    text-align: right;
    margin-top: 8px;
    margin-right: 90px;
}

.link {
    font-size: 16px;
    color: #1D1E25;
    font-weight: 400;
    margin-right: 10px;
}

.links-container {
    display: flex;
    justify-content: space-evenly;
    margin-top: -110px;
    margin-left: 100px;


}
#logout-exit-button{
    width: 120px !important;
}

@media (max-width: 360px) {
    .background-image {
        display: none;
    }

    .signIn {
        height: 56px;
        width:100%

    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 36px;
        line-height: 35px;
        font-weight: 100;
        margin-bottom: 12px;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 22px !important;

    }

    .logoBackgroundDiv {
        width: 30px;
        height: 150px;
        background-position: right;
        background-size: 400px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 127px !important;
        height: 100px !important;
    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }

    .Links {
        display: none;
    }
}



@media (min-width:361px) and (max-width: 375px) {
    .background-image {
        display: none;
    }

    .signIn {
        height: 56px;
        width: 100%;

    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 36px;
        line-height: 36px;
        margin-bottom: 12px;
        font-weight: 100;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 22px !important;

    }

    .logoBackgroundDiv {
        width: 300px;
        height: 150px;
        background-position: right;
        background-size: 400px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 127px !important;
        height: 100px !important;
    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }

    .Links {
        display: none;
    }
}

@media (min-width: 376px) and (max-width: 389px) {
    .background-image {
        display: none;
    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 36px;
        line-height: 35px;
        font-weight: 100;
        margin-bottom: 12px;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 22px !important;

    }

    .signIn {
        height: 56px;
        padding: 0px;
        width: 100%;

    }

    .logoBackgroundDiv {
        width: 300px;
        height: 150px;
        background-position: right;
        background-size: 400px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 127px !important;
        height: 100px !important;
    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }

    .Links {
        display: none;
    }

}

@media (min-width: 390px) and (max-width: 429px) {
    .background-image {
        display: none;
    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 36px;
        line-height: 36px;
        font-weight: 100;
        margin-bottom: 12px;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 22px !important;

    }

    .logoBackgroundDiv {
        width: 300px;
        height: 150px;
        background-position: right;
        background-size: 400px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 127px !important;
        height: 100px !important;
    }

    .signIn {
        height: 56px;
        width: 100%;

    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }
    .Links {
        display: none;
    }
}

@media (min-width: 430px) and (max-width: 539px) {
    .background-image {
        display: none;
    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 33px;
        line-height: 46px;
        font-weight: 100;
        margin-bottom: 12px;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 22px !important;

    }
    .logoBackgroundDiv {
        width: 300px;
        height: 150px;
        background-position: right;
        background-size: 400px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 127px !important;
        height: 100px !important;
    }

    .signIn {
        height: 56px;
        width: 100%;

    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }

    .Links {
        display: none;
    }
}

@media (min-width: 540px) and (max-width: 600px) {
    .background-image {
        display: none;
    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 36px;
        line-height: 46px;
        font-weight: 100;
        margin-bottom: 12px;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 26px !important;

    }

    .logoBackgroundDiv {
        width: 350px;
        height: 200px;
        background-position: right;
        background-size: 450px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 167px !important;
        height: 140px !important;
    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }

    .Links {
        display: none;
    }
}

@media (min-width: 601px) and (max-width: 767px) {
    .background-image {
        display: none;
    }

    .loginRight {
        max-width: 100% !important;
        background-color: transparent;
    }

    .headerTitle {
        font-size: 36px;
        line-height: 46px;
        font-weight: 100;
        margin-bottom: 12px;
    }

    .headerParagraph {
        font-size: 16px !important;
        line-height: 26px !important;

    }

    .logoBackgroundDiv {
        width: 350px;
        height: 200px;
        background-position: right;
        background-size: 450px;
        background-position-y: -75px;
    }

    .yerimLogo {
        width: 178px !important;
        height: 140px !important;
    }
    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw) !important;
        height: 100vh;
        margin: 0px !important;
        border-radius: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 40px;
        padding-bottom: 68px;
     }

    .Links {
        display: none;
    }
}


@media (min-width: 768px) and (max-width:1025px) {
    .logoBackgroundDiv {
        height: 120px !important;
        background-size: 350px;
        background-repeat: no-repeat;
        background-position-y: -70px;
        background-position-x: -90px;
    }

    .yerimLogo {
        height: 100px !important;
        width: 100px !important;
    }

    .login-form-container {
        background-size: 350px;
        background-position-y: -45px;
        background-position-x: -55px;
        width: calc(100vw - 300px) !important;
        height: calc(100vh - 60px);
        margin: 0px !important;
        border-radius: 0px;
        padding: 3vh;
        margin-top: 20px !important;
        margin-left: -150px !important;
        border-radius: 10px;
    }

    .loginRight {
        background-color: transparent;
    }

    .links-container {
        margin-top: -70px;
    }
}


/* @media (min-width: 1026px) and (max-width: 1600px) {
   
    .login-form-container {
        width: calc(100vh - 480px) !important;
        height:  calc(100vh - 80px);
        margin: 0px !important;
        border-radius: 0px;
        padding: 3vh;
        margin-top: 20px !important;
        margin-left: -150px !important;
        border-radius: 10px;
    }
    
}

@media (min-width: 1601px) and (max-width: 2000px) {
   
    .login-form-container {
        width: calc(100vh - 280px) !important;
        height:  calc(100vh - 80px);
        margin: 0px !important;
        border-radius: 0px;
        padding: 3vh;
        margin-top: 20px !important;
        margin-left: -150px !important;
        border-radius: 10px;
    }
    
} */
/* 
@media screen and (max-width: 800px) {

    .login-form-container {
        margin-left: -180px;
        margin-right: 100px;
    }

    .background-image {
        max-width: 40vh !important;
    }

    .loginRight {
        max-width: 40vh !important;
    }

    .logoBackground {
        width: 350px;
        height: 420px;
    }

    .yerimLogo {
        height: 150px !important;
        width: 150px !important;

    }

    h4 {
        font-size: 18px;
    }

    .headerParagraph {
        font-size: 12px;
    }

    .signIn {
        width: 212px;
        height: 45px;
        padding: 3px;
    }

    .Links {
        margin-right: 0px;

    }

    .Links a {
        font-size: 12px;
    }
} */

/* @media screen and (max-width: 700px) {
    .login-form-container {
        margin-left: -130px;
    }
} */

/* @media screen and (max-width: 600px) {
    .login-form-container {
        margin-left: -130px;
        width: 550px;
        height: 680px;
    }
} */
/* @media screen and (max-width: 1400px) {
    .login-form-container {
        margin-left: -170px;
    }
}

@media screen and (min-width: 2500px) {
    .login-form-container {
        margin-left: -170px;
    }
} */

.links-container {
    margin-left: 0px;
}

.logout-popup {
    top: 40%;
}

.logout-popup .modal-content {
    background-color: #e9a46b;
    color: #FFFFFF;
    font-weight: 400;
    border-radius: 15px;
    /* width: 70vh !important; */
}

.logout-popup button {
    background-color: transparent;
    width: 120px;
    height: 35px;
    border-radius: 20px !important;
    border: 1px solid #1D1E2599;

}

.logout-popup .modal-footer {
    border-top: none;
}

.logout-popup .modal-header {
    border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/LoginStyles.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,yDAA0D;IAC1D,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,yDAAiD;IACjD,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,wCAAwC;IACxC,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IAEI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;;;AAGrB;;AAEA;IAEI,gBAAgB;IAChB,aAAa;IACb,iBAAiB;;;;AAIrB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;;AAE7B;;;;AAIA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;;;AAGtB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ;;IAEJ;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;;IAEA;QACI,WAAW;QACX,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;;IAED;QACI,aAAa;IACjB;AACJ;;;;AAIA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,WAAW;;IAEf;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;;IAED;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,WAAW;;IAEf;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;;IAED;QACI,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,WAAW;;IAEf;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;IACD;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;IACA;QACI,YAAY;QACZ,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,YAAY;QACZ,WAAW;;IAEf;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;;IAED;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;;IAED;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,4BAA4B;;IAEhC;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,0BAA0B;QAC1B,sBAAsB;QACtB,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;IACA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;KACvB;;IAED;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,wBAAwB;QACxB,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,4BAA4B;IAChC;;IAEA;QACI,wBAAwB;QACxB,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,4BAA4B;QAC5B,4BAA4B;QAC5B,qCAAqC;QACrC,0BAA0B;QAC1B,sBAAsB;QACtB,kBAAkB;QAClB,YAAY;QACZ,2BAA2B;QAC3B,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA4BG;AACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiDG;;AAEH;;;;GAIG;;AAEH;;;;;;GAMG;AACH;;;;;;;;;;GAUG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,2BAA2B;;AAE/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["* {\n    font-family: 'Sora', sans-serif;\n}\n\n.loginRight {\n    background-color: hsl(200, 33%, 98%);\n    width: 50%;\n    height: 100vh;\n}\n\n.background-image {\n    background-image: url('../images/BackgroundLoginLeft.png');\n    max-width: 100%;\n    height: 100vh;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.login-form-container {\n    background-image: url('../images/Pattern\\ 2.png');\n    background-repeat: no-repeat;\n    background-position-y:-10px;\n    background-position-x:-30px;\n    width: 100% !important;\n    height: calc(100vh - 60px);\n    background-color: #FFFFFF;\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.1);\n    padding: 66px 106px 26px 66px;\n    margin-top: 20px;\n    margin-bottom: 50px;\n    border-radius: 8px;\n    margin-left: -80px;\n    margin-right: 50px;\n    overflow-y: auto;\n}\n\n.appVersion {\n    text-align: left;\n    font-size: 12px;\n}\n\n\n.login-password {\n    border-radius: 12px !important;\n}\n\n.login-email {\n    border-radius: 12px !important;\n\n}\n\n.headerTitle {\n    font-family: 'Sora', sans-serif;\n    font-weight: 100 !important;\n    color: #1D1E25;\n}\n\n.headerParagraph {\n    font-family: 'Sora', sans-serif;\n    font-weight: 200 !important;\n    font-size: 16px;\n    line-height: 26px;\n    color: #1D1E2599;\n    margin-bottom: 40px;\n}\n\n.headerLink {\n    color: #F15F50;\n    font-size: 20px;\n    line-height: 30px;\n    text-align: right;\n    text-decoration: underline;\n}\n\n#email,\n#password {\n    border-radius: 5px;\n    border-left: none;\n    margin-left: 15px;\n}\n\n#email:focus {\n    -webkit-box-shadow: #e9a46b !important;\n    box-shadow: none;\n    outline: none;\n    border-left: none;\n\n\n}\n\n#password:focus {\n    -webkit-box-shadow: #e9a46b !important;\n    box-shadow: none;\n    outline: none;\n    border-left: none;\n\n\n\n}\n\n.input-group {\n    width: 100%;\n}\n\n/* .input-with-icon {\n    padding-left: 40px;\n    background-repeat: no-repeat;\n    background-position: 10px center;\n}\n\n.input-with-icon#email {\n    background: url('../images/icons/Email.png') no-repeat scroll 10px center;\n    margin-left: -40px;\n}\n\n.input-with-icon#password {\n    background: url('../images/icons/Password.png') no-repeat scroll 10px center;\n    margin-left: -40px;\n} */\n\n.form-control {\n    color: #1D1E25;\n    margin-bottom: 15px;\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.logoBackgroundDiv {\n    width: 400px;\n    height: 200px;\n    margin-bottom: 20px;\n\n}\n\n.yerimLogo {\n    width: 229px !important;\n    height: 180px !important;\n    z-index: 9999;\n}\n\n.forgotPasswordDiv {\n    display: flex;\n    text-align: right;\n    justify-content: end;\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.forgotPasswordDiv p {\n    color: #ed5746;\n}\n\n.forgotPassword {\n    color: #1D1E25;\n    font-size: 14px;\n}\n\n.signIn {\n    /* padding: 18px 22px 18px 22px; */\n    width: 312px;\n    height: 56px;\n    background-color: #F15F50;\n    justify-content: space-between;\n    border-radius: 12px;\n    border: none;\n    margin-top: 10px;\n}\n\n.signIn:hover {\n    background-color: #ed5746;\n\n}\n\n\n\n.eyeButton {\n    border: none;\n    margin-left: -50px;\n    margin-top: 10px;\n    z-index: 999 !important;\n}\n\n.envelopeIcon,\n.keyIcon {\n    margin-top: 15px;\n    margin-right: -5px;\n    z-index: 999;\n}\n\n.loginHeader {\n    margin-bottom: 20px;\n}\n\n\n\n.Links {\n    text-align: right;\n    margin-top: 8px;\n    margin-right: 90px;\n}\n\n.link {\n    font-size: 16px;\n    color: #1D1E25;\n    font-weight: 400;\n    margin-right: 10px;\n}\n\n.links-container {\n    display: flex;\n    justify-content: space-evenly;\n    margin-top: -110px;\n    margin-left: 100px;\n\n\n}\n#logout-exit-button{\n    width: 120px !important;\n}\n\n@media (max-width: 360px) {\n    .background-image {\n        display: none;\n    }\n\n    .signIn {\n        height: 56px;\n        width:100%\n\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 36px;\n        line-height: 35px;\n        font-weight: 100;\n        margin-bottom: 12px;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 22px !important;\n\n    }\n\n    .logoBackgroundDiv {\n        width: 30px;\n        height: 150px;\n        background-position: right;\n        background-size: 400px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 127px !important;\n        height: 100px !important;\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n\n    .Links {\n        display: none;\n    }\n}\n\n\n\n@media (min-width:361px) and (max-width: 375px) {\n    .background-image {\n        display: none;\n    }\n\n    .signIn {\n        height: 56px;\n        width: 100%;\n\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 36px;\n        line-height: 36px;\n        margin-bottom: 12px;\n        font-weight: 100;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 22px !important;\n\n    }\n\n    .logoBackgroundDiv {\n        width: 300px;\n        height: 150px;\n        background-position: right;\n        background-size: 400px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 127px !important;\n        height: 100px !important;\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n\n    .Links {\n        display: none;\n    }\n}\n\n@media (min-width: 376px) and (max-width: 389px) {\n    .background-image {\n        display: none;\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 36px;\n        line-height: 35px;\n        font-weight: 100;\n        margin-bottom: 12px;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 22px !important;\n\n    }\n\n    .signIn {\n        height: 56px;\n        padding: 0px;\n        width: 100%;\n\n    }\n\n    .logoBackgroundDiv {\n        width: 300px;\n        height: 150px;\n        background-position: right;\n        background-size: 400px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 127px !important;\n        height: 100px !important;\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n\n    .Links {\n        display: none;\n    }\n\n}\n\n@media (min-width: 390px) and (max-width: 429px) {\n    .background-image {\n        display: none;\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 36px;\n        line-height: 36px;\n        font-weight: 100;\n        margin-bottom: 12px;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 22px !important;\n\n    }\n\n    .logoBackgroundDiv {\n        width: 300px;\n        height: 150px;\n        background-position: right;\n        background-size: 400px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 127px !important;\n        height: 100px !important;\n    }\n\n    .signIn {\n        height: 56px;\n        width: 100%;\n\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n    .Links {\n        display: none;\n    }\n}\n\n@media (min-width: 430px) and (max-width: 539px) {\n    .background-image {\n        display: none;\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 33px;\n        line-height: 46px;\n        font-weight: 100;\n        margin-bottom: 12px;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 22px !important;\n\n    }\n    .logoBackgroundDiv {\n        width: 300px;\n        height: 150px;\n        background-position: right;\n        background-size: 400px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 127px !important;\n        height: 100px !important;\n    }\n\n    .signIn {\n        height: 56px;\n        width: 100%;\n\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n\n    .Links {\n        display: none;\n    }\n}\n\n@media (min-width: 540px) and (max-width: 600px) {\n    .background-image {\n        display: none;\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 36px;\n        line-height: 46px;\n        font-weight: 100;\n        margin-bottom: 12px;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 26px !important;\n\n    }\n\n    .logoBackgroundDiv {\n        width: 350px;\n        height: 200px;\n        background-position: right;\n        background-size: 450px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 167px !important;\n        height: 140px !important;\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n\n    .Links {\n        display: none;\n    }\n}\n\n@media (min-width: 601px) and (max-width: 767px) {\n    .background-image {\n        display: none;\n    }\n\n    .loginRight {\n        max-width: 100% !important;\n        background-color: transparent;\n    }\n\n    .headerTitle {\n        font-size: 36px;\n        line-height: 46px;\n        font-weight: 100;\n        margin-bottom: 12px;\n    }\n\n    .headerParagraph {\n        font-size: 16px !important;\n        line-height: 26px !important;\n\n    }\n\n    .logoBackgroundDiv {\n        width: 350px;\n        height: 200px;\n        background-position: right;\n        background-size: 450px;\n        background-position-y: -75px;\n    }\n\n    .yerimLogo {\n        width: 178px !important;\n        height: 140px !important;\n    }\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw) !important;\n        height: 100vh;\n        margin: 0px !important;\n        border-radius: 0px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-top: 40px;\n        padding-bottom: 68px;\n     }\n\n    .Links {\n        display: none;\n    }\n}\n\n\n@media (min-width: 768px) and (max-width:1025px) {\n    .logoBackgroundDiv {\n        height: 120px !important;\n        background-size: 350px;\n        background-repeat: no-repeat;\n        background-position-y: -70px;\n        background-position-x: -90px;\n    }\n\n    .yerimLogo {\n        height: 100px !important;\n        width: 100px !important;\n    }\n\n    .login-form-container {\n        background-size: 350px;\n        background-position-y: -45px;\n        background-position-x: -55px;\n        width: calc(100vw - 300px) !important;\n        height: calc(100vh - 60px);\n        margin: 0px !important;\n        border-radius: 0px;\n        padding: 3vh;\n        margin-top: 20px !important;\n        margin-left: -150px !important;\n        border-radius: 10px;\n    }\n\n    .loginRight {\n        background-color: transparent;\n    }\n\n    .links-container {\n        margin-top: -70px;\n    }\n}\n\n\n/* @media (min-width: 1026px) and (max-width: 1600px) {\n   \n    .login-form-container {\n        width: calc(100vh - 480px) !important;\n        height:  calc(100vh - 80px);\n        margin: 0px !important;\n        border-radius: 0px;\n        padding: 3vh;\n        margin-top: 20px !important;\n        margin-left: -150px !important;\n        border-radius: 10px;\n    }\n    \n}\n\n@media (min-width: 1601px) and (max-width: 2000px) {\n   \n    .login-form-container {\n        width: calc(100vh - 280px) !important;\n        height:  calc(100vh - 80px);\n        margin: 0px !important;\n        border-radius: 0px;\n        padding: 3vh;\n        margin-top: 20px !important;\n        margin-left: -150px !important;\n        border-radius: 10px;\n    }\n    \n} */\n/* \n@media screen and (max-width: 800px) {\n\n    .login-form-container {\n        margin-left: -180px;\n        margin-right: 100px;\n    }\n\n    .background-image {\n        max-width: 40vh !important;\n    }\n\n    .loginRight {\n        max-width: 40vh !important;\n    }\n\n    .logoBackground {\n        width: 350px;\n        height: 420px;\n    }\n\n    .yerimLogo {\n        height: 150px !important;\n        width: 150px !important;\n\n    }\n\n    h4 {\n        font-size: 18px;\n    }\n\n    .headerParagraph {\n        font-size: 12px;\n    }\n\n    .signIn {\n        width: 212px;\n        height: 45px;\n        padding: 3px;\n    }\n\n    .Links {\n        margin-right: 0px;\n\n    }\n\n    .Links a {\n        font-size: 12px;\n    }\n} */\n\n/* @media screen and (max-width: 700px) {\n    .login-form-container {\n        margin-left: -130px;\n    }\n} */\n\n/* @media screen and (max-width: 600px) {\n    .login-form-container {\n        margin-left: -130px;\n        width: 550px;\n        height: 680px;\n    }\n} */\n/* @media screen and (max-width: 1400px) {\n    .login-form-container {\n        margin-left: -170px;\n    }\n}\n\n@media screen and (min-width: 2500px) {\n    .login-form-container {\n        margin-left: -170px;\n    }\n} */\n\n.links-container {\n    margin-left: 0px;\n}\n\n.logout-popup {\n    top: 40%;\n}\n\n.logout-popup .modal-content {\n    background-color: #e9a46b;\n    color: #FFFFFF;\n    font-weight: 400;\n    border-radius: 15px;\n    /* width: 70vh !important; */\n}\n\n.logout-popup button {\n    background-color: transparent;\n    width: 120px;\n    height: 35px;\n    border-radius: 20px !important;\n    border: 1px solid #1D1E2599;\n\n}\n\n.logout-popup .modal-footer {\n    border-top: none;\n}\n\n.logout-popup .modal-header {\n    border-bottom: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
